type TgenerateLink = {
  slug: TVehicleSelection;
  partSlug: string;
  categorySlug: string;
  getLink: any;
  reference?: string | undefined;
};

const generateLink = ({
  getLink,
  slug,
  partSlug,
  categorySlug,
  reference,
}: TgenerateLink) => {
  if (reference) {
    return getLink('search', {
      reference: reference!,
      ...(categorySlug &&
        partSlug && {
        category: categorySlug,
        subCategory: partSlug,
      }),
      ...(slug && { vehicle: slug }),
    });
  } else {
    return getLink('search',
      {
        ...(partSlug && { subCategory: partSlug }),
        ...(categorySlug && { category: categorySlug }),
        ...(slug && { vehicle: slug }),
      }
    );
  }
};

export default generateLink;
